// Common country codes
export const COUNTRY_CODES = [
  { code: "+1", country: "US/CA", flag: "🇺🇸" },
  { code: "+44", country: "UK", flag: "🇬🇧" },
  { code: "+61", country: "AU", flag: "🇦🇺" },
  { code: "+91", country: "IN", flag: "🇮🇳" },
  { code: "+86", country: "CN", flag: "🇨🇳" },
  { code: "+81", country: "JP", flag: "🇯🇵" },
  { code: "+49", country: "DE", flag: "🇩🇪" },
  { code: "+33", country: "FR", flag: "🇫🇷" },
  { code: "+39", country: "IT", flag: "🇮🇹" },
  { code: "+34", country: "ES", flag: "🇪🇸" },
  { code: "+31", country: "NL", flag: "🇳🇱" },
  { code: "+41", country: "CH", flag: "🇨🇭" },
  { code: "+46", country: "SE", flag: "🇸🇪" },
  { code: "+47", country: "NO", flag: "🇳🇴" },
  { code: "+45", country: "DK", flag: "🇩🇰" },
  { code: "+32", country: "BE", flag: "🇧🇪" },
  { code: "+351", country: "PT", flag: "🇵🇹" },
  { code: "+353", country: "IE", flag: "🇮🇪" },
  { code: "+358", country: "FI", flag: "🇫🇮" },
  { code: "+64", country: "NZ", flag: "🇳🇿" },
  { code: "+27", country: "ZA", flag: "🇿🇦" },
  { code: "+55", country: "BR", flag: "🇧🇷" },
  { code: "+52", country: "MX", flag: "🇲🇽" },
  { code: "+971", country: "AE", flag: "🇦🇪" },
  { code: "+65", country: "SG", flag: "🇸🇬" },
  { code: "+60", country: "MY", flag: "🇲🇾" },
  { code: "+66", country: "TH", flag: "🇹🇭" },
  { code: "+84", country: "VN", flag: "🇻🇳" },
  { code: "+62", country: "ID", flag: "🇮🇩" },
  { code: "+63", country: "PH", flag: "🇵🇭" },
];

// United States States
export const US_STATES = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

// Form schema based on provided JSON
export const COMPANY_CREATE_FORM_SCHEMA = {
  BasicCompanyInformation: [
    {
      label: "Company Name",
      name: "company_name",
      field_type: "text",
      isRequired: true,
      maxLength: 255,
    },
    {
      label: "Parent Company",
      name: "parent_company",
      field_type: "text",
      isRequired: false,
      maxLength: 255,
    },
    {
      label: "Company Formation Type",
      name: "company_formation_type",
      field_type: "select",
      isRequired: false,
      maxLength: 100,
      options: [
        "Individual/Sole Proprietor",
        "C Corporation",
        "S Corporation",
        "Partnership",
        "Trust/Estate",
        "LLC",
      ],
    },
    {
      label: "Status",
      name: "status",
      field_type: "select",
      isRequired: true,
      maxLength: 50,
      options: ["Qualified Lead", "Active Account", "DNC", "Archive"],
    },
    {
      label: "Company Website",
      name: "company_website",
      field_type: "text",
      isRequired: false,
      maxLength: 500,
    },
    {
      label: "Ownership Type",
      name: "ownership_type",
      field_type: "select",
      isRequired: false,
      maxLength: 50,
      options: ["Public", "Private", "Government", "Non Profit"],
    },
    {
      label: "Company Overview",
      name: "company_overview",
      field_type: "textarea",
      isRequired: false,
    },
    {
      label: "Company Description",
      name: "company_description",
      field_type: "textarea",
      isRequired: false,
    },
  ],
  FinancialInformation: [
    {
      label: "Standard Perm Fee Percentage",
      name: "standard_perm_fee_percentage",
      field_type: "number",
      isRequired: false,
    },
    {
      label: "Industry",
      name: "industry",
      field_type: "select",
      isRequired: false,
      maxLength: 255,
      options: [
        "CPG",
        "Financial Services",
        "Government",
        "Oil & Gas",
        "Real Estate",
        "Retail",
        "Utilities",
      ],
    },
    {
      label: "Currency",
      name: "currency",
      field_type: "select",
      isRequired: false,
      maxLength: 10,
      default: "USD",
      options: ["USD", "CAD", "GBP", "PLN", "EUR", "AUD", "DKK", "AED", "INR"],
    },
  ],
  ManagementInformation: [
    {
      label: "Account Manager",
      name: "account_manager",
      field_type: "text",
      isRequired: true,
      maxLength: 255,
    },
  ],
  LocationInformation: [
    {
      label: "Main Phone Country Code",
      name: "main_phone_country_code",
      field_type: "text",
      isRequired: true,
      maxLength: 10,
      default: "+1",
    },
    {
      label: "Main Phone Number",
      name: "main_phone_number",
      field_type: "text",
      isRequired: true,
      maxLength: 10,
      minLength: 10,
    },
    {
      label: "Address",
      name: "address",
      field_type: "text",
      isRequired: true,
      maxLength: 500,
    },
    {
      label: "Address 2",
      name: "address2",
      field_type: "text",
      isRequired: true,
      maxLength: 500,
    },
    {
      label: "City",
      name: "city",
      field_type: "text",
      isRequired: true,
      maxLength: 100,
    },
    {
      label: "State",
      name: "state",
      field_type: "select",
      isRequired: true,
      maxLength: 100,
      options: US_STATES,
    },
    {
      label: "Zip Code",
      name: "zip_code",
      field_type: "text",
      isRequired: true,
      maxLength: 20,
    },
    {
      label: "Country",
      name: "country",
      field_type: "text",
      isRequired: true,
      maxLength: 100,
      default: "United States",
    },
  ],
  BillingInformation: [
    {
      label: "Billing Contact",
      name: "billing_contact",
      field_type: "text",
      isRequired: true,
      maxLength: 255,
    },
    {
      label: "Billing Frequency",
      name: "billing_frequency",
      field_type: "select",
      isRequired: false,
      maxLength: 50,
      options: ["Weekly", "Bi-Weekly", "Semi-Monthly", "Monthly"],
    },
    {
      label: "Billing Phone Country Code",
      name: "billing_phone_country_code",
      field_type: "text",
      isRequired: true,
      maxLength: 10,
      default: "+1",
    },
    {
      label: "Billing Phone Number",
      name: "billing_phone_number",
      field_type: "text",
      isRequired: true,
      maxLength: 10,
      minLength: 10,
    },
  ],
  InvoicingInformation: [
    {
      label: "Invoice Frequency",
      name: "invoice_frequency",
      field_type: "select",
      isRequired: true,
      maxLength: 50,
      options: ["Weekly", "Bi-Weekly", "Bi-Monthly", "Batch", "Monthly"],
    },
    {
      label: "Batch Name",
      name: "batch_name",
      field_type: "text",
      isRequired: true,
      maxLength: 255,
    },
    {
      label: "Invoice Format",
      name: "invoice_format",
      field_type: "select",
      isRequired: true,
      maxLength: 255,
      options: [
        "All Placements On One Invoice",
        "Each Placement on Separate Invoice",
        "Placement Grouped by Variable",
      ],
    },
    {
      label: "Net Terms",
      name: "net_terms",
      field_type: "number",
      isRequired: true,
    },
  ],
};
